// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEmploymentProfileDto } from './IEmploymentProfileDto';
import {
    IEmploymentProfileDtoFromJSON,
    IEmploymentProfileDtoFromJSONTyped,
    IEmploymentProfileDtoToJSON,
    IEmploymentProfileDtoToJSONTyped,
} from './IEmploymentProfileDto';
import type { IInvestorProfileDto } from './IInvestorProfileDto';
import {
    IInvestorProfileDtoFromJSON,
    IInvestorProfileDtoFromJSONTyped,
    IInvestorProfileDtoToJSON,
    IInvestorProfileDtoToJSONTyped,
} from './IInvestorProfileDto';
import type { IInvestorAccountDto } from './IInvestorAccountDto';
import {
    IInvestorAccountDtoFromJSON,
    IInvestorAccountDtoFromJSONTyped,
    IInvestorAccountDtoToJSON,
    IInvestorAccountDtoToJSONTyped,
} from './IInvestorAccountDto';

/**
 * 
 * @export
 * @interface IInvestorDto
 */
export interface IInvestorDto {
    /**
     * 
     * @type {number}
     * @memberof IInvestorDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorDto
     */
    external_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IInvestorDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorDto
     */
    external_bank_account_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IInvestorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorDto
     */
    type?: IInvestorDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestorDto
     */
    status?: IInvestorDtoStatusEnum;
    /**
     * 
     * @type {IEmploymentProfileDto}
     * @memberof IInvestorDto
     */
    employment_profile?: IEmploymentProfileDto;
    /**
     * 
     * @type {IInvestorProfileDto}
     * @memberof IInvestorDto
     */
    investor_profile?: IInvestorProfileDto;
    /**
     * 
     * @type {number}
     * @memberof IInvestorDto
     */
    age?: number;
    /**
     * 
     * @type {IInvestorAccountDto}
     * @memberof IInvestorDto
     */
    account?: IInvestorAccountDto;
    /**
     * 
     * @type {Set<number>}
     * @memberof IInvestorDto
     */
    full_liquidation_instrument_ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IInvestorDto
     */
    initial_investment_amount?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IInvestorDto
     */
    amounts_grouped_by_instrument_ids?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof IInvestorDto
     */
    automatic_investment_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IInvestorDto
     */
    risk_tolerance_model?: IInvestorDtoRiskToleranceModelEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestorDto
     */
    investment_balance?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorDto
     */
    auto_invest_scheduling_status?: IInvestorDtoAutoInvestSchedulingStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestorDto
     */
    amount_to_keep?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IInvestorDto
     */
    investment_model_switching?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IInvestorDto
     */
    full_liquidation_in_progress?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IInvestorDtoTypeEnum {
    MANAGED = 'MANAGED',
    BROKERAGE = 'BROKERAGE',
    SELF_DIRECTED = 'SELF_DIRECTED'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorDtoStatusEnum {
    INVESTOR_CREATED = 'INVESTOR_CREATED',
    INVESTMENT_PATH_SELECTED = 'INVESTMENT_PATH_SELECTED',
    QUESTIONNAIRE_FILLED = 'QUESTIONNAIRE_FILLED',
    INVESTMENT_AMOUNT_SELECTED = 'INVESTMENT_AMOUNT_SELECTED',
    PENDING_EXTERNAL_CREATION = 'PENDING_EXTERNAL_CREATION',
    ACTIVE = 'ACTIVE'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorDtoRiskToleranceModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorDtoAutoInvestSchedulingStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED'
}


/**
 * Check if a given object implements the IInvestorDto interface.
 */
export function instanceOfIInvestorDto(value: object): value is IInvestorDto {
    return true;
}

export function IInvestorDtoFromJSON(json: any): IInvestorDto {
    return IInvestorDtoFromJSONTyped(json, false);
}

export function IInvestorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'external_bank_account_id': json['external_bank_account_id'] == null ? undefined : json['external_bank_account_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'employment_profile': json['employment_profile'] == null ? undefined : IEmploymentProfileDtoFromJSON(json['employment_profile']),
        'investor_profile': json['investor_profile'] == null ? undefined : IInvestorProfileDtoFromJSON(json['investor_profile']),
        'age': json['age'] == null ? undefined : json['age'],
        'account': json['account'] == null ? undefined : IInvestorAccountDtoFromJSON(json['account']),
        'full_liquidation_instrument_ids': json['full_liquidation_instrument_ids'] == null ? undefined : new Set(json['full_liquidation_instrument_ids']),
        'initial_investment_amount': json['initial_investment_amount'] == null ? undefined : json['initial_investment_amount'],
        'amounts_grouped_by_instrument_ids': json['amounts_grouped_by_instrument_ids'] == null ? undefined : json['amounts_grouped_by_instrument_ids'],
        'automatic_investment_enabled': json['automatic_investment_enabled'] == null ? undefined : json['automatic_investment_enabled'],
        'risk_tolerance_model': json['risk_tolerance_model'] == null ? undefined : json['risk_tolerance_model'],
        'investment_balance': json['investment_balance'] == null ? undefined : json['investment_balance'],
        'auto_invest_scheduling_status': json['auto_invest_scheduling_status'] == null ? undefined : json['auto_invest_scheduling_status'],
        'amount_to_keep': json['amount_to_keep'] == null ? undefined : json['amount_to_keep'],
        'investment_model_switching': json['investment_model_switching'] == null ? undefined : json['investment_model_switching'],
        'full_liquidation_in_progress': json['full_liquidation_in_progress'] == null ? undefined : json['full_liquidation_in_progress'],
    };
}

export function IInvestorDtoToJSON(json: any): IInvestorDto {
    return IInvestorDtoToJSONTyped(json, false);
}

export function IInvestorDtoToJSONTyped(value?: IInvestorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'external_id': value['external_id'],
        'account_id': value['account_id'],
        'external_bank_account_id': value['external_bank_account_id'],
        'employee_id': value['employee_id'],
        'type': value['type'],
        'status': value['status'],
        'employment_profile': IEmploymentProfileDtoToJSON(value['employment_profile']),
        'investor_profile': IInvestorProfileDtoToJSON(value['investor_profile']),
        'age': value['age'],
        'account': IInvestorAccountDtoToJSON(value['account']),
        'full_liquidation_instrument_ids': value['full_liquidation_instrument_ids'] == null ? undefined : Array.from(value['full_liquidation_instrument_ids'] as Set<any>),
        'initial_investment_amount': value['initial_investment_amount'],
        'amounts_grouped_by_instrument_ids': value['amounts_grouped_by_instrument_ids'],
        'automatic_investment_enabled': value['automatic_investment_enabled'],
        'risk_tolerance_model': value['risk_tolerance_model'],
        'investment_balance': value['investment_balance'],
        'auto_invest_scheduling_status': value['auto_invest_scheduling_status'],
        'amount_to_keep': value['amount_to_keep'],
        'investment_model_switching': value['investment_model_switching'],
        'full_liquidation_in_progress': value['full_liquidation_in_progress'],
    };
}

